import { useEffect } from "react";

import { connect } from "react-redux";

import { loadUmbracoContent } from "../redux/actions";

/**
 * In the MembersArea.cshtml file there are some variables contained within html elements. This
 * hook grabs the innerHTML of the appropriate element and saves it to the redux store.
 */
const getSubtitles = () => {
  const getElementHtml = (elementId) => {
    const element = document.getElementById(elementId);
    return element ? element.innerHTML : "";
  };

  const subtitles = {
    desiredPositionSub: getElementHtml("desiredPositionSub"),
    profileImageSub: getElementHtml("profileImageSub"),
    addressSub: getElementHtml("addressSub"),
    updateSub: getElementHtml("updateSub"),
    cvUploadSub: getElementHtml("cvUploadSub"),
    workTypeSub: getElementHtml("workTypeSub"),
    nameSub: getElementHtml("nameSub"),
    personalDeclarationSub: getElementHtml("personalDeclarationSub"),
  };
  return subtitles;
};

const useUmbracoContent = (loadContent) =>
  useEffect(() => {
    loadContent({
      ...getSubtitles(),
      branches: window._umbraco_branches || [],
      resources: window._umbraco_resources || [],
      readingList: window._umbraco_readingList || [],
      greatBearReadingList: window._umbraco_greatBearReadingList || [],
      kingspanReadingList: window._umbraco_kingspanReadingList || [],
      pusterlaReadingList: window._umbraco_pusterlaReadingList || [],
      regattaReadingList: window._umbraco_regattaReadingList || [],
      SOPDocsLine1: window._umbraco_SOPDocsLine1 || [],
      SOPDocsLine24: window._umbraco_SOPDocsLine24 || [],
      SOPDocsLine3: window._umbraco_SOPDocsLine3 || [],
      SOPDocsShop1: window._umbraco_SOPDocsShop1 || [],
      pecanReadingList: window._umbraco_pecanReadingList || [],
      carltonForestReadingList: window._umbraco_carltonForestReadingList || [],
      SSOWHandBaller: window._umbraco_SSOW_HandBaller || [],
      SSOWMaterialHandling: window._umbraco_SSOW_MaterialHandling || [],
      cpiReadingList: window._umbraco_cpiReadingList || [],
      compleatFoodReadingList: window._umbraco_compleatFoodReadingList || [],
      woodlandReadingList: window._umbraco_woodlandReadingList || [],
      molecularReadingList: window._umbraco_molecularReadingList || [],
      molecularReadingListDocs: window._umbraco_molecularReadingListDocs || [],
      thanetCouncilReadingList: window._umbraco_thanetCouncilReadingList || [],
      thanetCouncilRiskAssessmentDriver:
        window._umbraco_thanetCouncilRiskAssessmentDriver || [],
      thanetCouncilRiskAssessmentNonDriver:
        window._umbraco_thanetCouncilRiskAssessmentNonDriver || [],
      growUpFarmsReadingList: window._umbraco_growUpFarmsReadingList || [],
      davinFoodsReadingList: window._umbraco_davinFoodsReadingList || [],
    });
  }, []);

const UmbracoContent = ({ children, loadContent }) => {
  useUmbracoContent(loadContent);
  return children;
};

const mapDispatchedProps = { loadContent: loadUmbracoContent };

const withRedux = connect(null, mapDispatchedProps);

export default withRedux(UmbracoContent);
